import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gratuity',
  templateUrl: './gratuity.component.html',
  styleUrls: ['./gratuity.component.scss']
})
export class GratuityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
